import { render, staticRenderFns } from "./MantenedorGridVerDetalle.vue?vue&type=template&id=644bccfd&"
import script from "./MantenedorGridVerDetalle.vue?vue&type=script&lang=ts&"
export * from "./MantenedorGridVerDetalle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('644bccfd', component.options)
    } else {
      api.reload('644bccfd', component.options)
    }
    module.hot.accept("./MantenedorGridVerDetalle.vue?vue&type=template&id=644bccfd&", function () {
      api.rerender('644bccfd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/reusable/Grid/MantenedorGridVerDetalle.vue"
export default component.exports